import { h } from 'preact'
import styles from './footer.module.css'

export const Author = ({ email, displayname, role }) => (
  <div className={styles.person}>
    <a href={`mailto:${email}`} className={styles.name}>
      {displayname}
    </a>
    <div className={styles.role}>{role}</div>
  </div>
)
